/*
 * A random, persistent id for this browser. The server binds each session to
 * it, so a copied session cookie is useless from another browser, and it lets
 * the sessions list recognise "this device". It is not a fingerprint and holds
 * no personal data.
 */
const DEVICE_ID_KEY = "gw_device_id";
const AUTH_HINT_KEY = "gw_customer_signed_in";

let memoryDeviceId = null;

const createUuid = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();

  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex
    .slice(6, 8)
    .join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
};

export const getDeviceId = () => {
  try {
    let deviceId = window.localStorage.getItem(DEVICE_ID_KEY);

    if (!deviceId) {
      deviceId = createUuid();
      window.localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }

    return deviceId;
  } catch {
    // Storage blocked (private mode): keep one id for this page lifetime.
    memoryDeviceId = memoryDeviceId || createUuid();
    return memoryDeviceId;
  }
};

/*
 * The session cookie is httpOnly, so the page cannot see it. This flag only
 * records "we signed in here" so guests skip the /auth/verify round trip.
 * It grants nothing on its own.
 */
export const hasAuthHint = () => {
  try {
    return window.localStorage.getItem(AUTH_HINT_KEY) === "1";
  } catch {
    return true;
  }
};

export const setAuthHint = (signedIn) => {
  try {
    if (signedIn) {
      window.localStorage.setItem(AUTH_HINT_KEY, "1");
    } else {
      window.localStorage.removeItem(AUTH_HINT_KEY);
    }

    // Tokens stored by the previous login system.
    window.localStorage.removeItem("accessToken");
  } catch {
    // Nothing to persist.
  }
};
